import { ValidationKey } from '@seiri/shared/common'

/**
 * Slovak wording of every Seiri validation rule. `Record<ValidationKey, …>`, so a key added to
 * `VALIDATION_MESSAGES_EN` is a compile error here until it is translated. Each shows as one line
 * under a field, so keep it short; a rule that needs explaining gets a `mat-hint` as well.
 */
export const VALIDATION_SK: Record<ValidationKey, string> = {
  'validation.required': 'Povinné pole',
  'validation.endAfterStart': 'Koniec musí byť po začiatku',
  'validation.startInPast': 'Začiatok nemôže byť v minulosti',
  'validation.beyondPlanningHorizon': 'Služba môže platiť najviac 6 mesiacov dopredu',
  'validation.timeFormat': 'Čas musí byť vo formáte HH:mm',
  'validation.openingHoursOverlap': 'Intervaly sa nesmú prekrývať',
  'validation.timezone': 'Neplatné časové pásmo',
  'validation.ageRange': 'Nesprávne vekové rozpätie',
  'validation.passwordStrength': 'Min. 8 znakov, 3 zo 4: a–z, A–Z, 0–9, symbol',
  'validation.passwordsMatch': 'Heslá sa musia zhodovať',
  'validation.phoneCharacters': 'Iba číslice, medzery a znaky + / -',
  'validation.phoneMinLength': 'Telefón musí mať aspoň 4 znaky',
  'validation.consentRequired': 'Súhlas je povinný',
  'validation.emailsRequired': 'Pridajte aspoň jeden email',
  'validation.clientsRequired': 'Vyberte aspoň jedného klienta',
  'validation.activityRequired': 'Vyberte činnosť',
  'validation.placeRequired': 'Vyberte miesto',
  'validation.colorRequired': 'Vyberte farbu',
  'validation.placesRequired': 'Vyberte miesta alebo „Nepriradiť miesto“',
  'validation.employeesRequired': 'Vyberte zamestnancov alebo „Nepriradiť zamestnanca“',
  'validation.intervalsRequired': 'Pridajte aspoň jeden časový interval',
  'validation.weekdaysRequired': 'Vyberte aspoň jeden deň',
  'validation.weeksRequired': 'Vyberte aspoň jeden týždeň',
  'validation.reoccurEndRequired': 'Zadajte buď dátum ukončenia, alebo počet opakovaní',
  'validation.reoccurCountRequired': 'Zadajte počet opakovaní',
  'validation.reoccurUntilRequired': 'Zadajte dátum, do kedy sa má opakovať',
  'validation.reoccurUntilAfterStart': 'Opakovanie musí skončiť po jeho začiatku',
  'validation.blueprintOrActivityRequired': 'Vyberte službu alebo činnosť',
  'validation.slotRangeTooLong': 'Obdobie môže mať najviac 31 dní',
  'validation.eventRangeTooLong': 'Obdobie môže mať najviac 92 dní',
  'validation.eventOrCustomerRequired': 'Vyberte udalosť alebo klienta',
  'validation.mjmlXorHtml': 'Zadajte buď MJML, alebo HTML obsah, nie oboje',
  'validation.httpUrl': 'Zadajte platnú webovú adresu, napr. https://example.com',
  'validation.duplicateOrigin': 'Táto doména už je v zozname',
  'validation.galleryOrder': 'Galéria sa medzitým zmenila. Obnovte stránku a skúste to znova.',
}
